fragment AssetCheckFields on AssetCheck {
  id
  source
  result
  checkedOn
  checkedVia
  checkedByName
  externalRef
  notes
}
